import { GenericValue } from 'hisng';
import { Component } from '@angular/core';
import { WithDatasourceComponent } from './with-datasource.component';

@Component( {
    selector: 'erp-pbw-titel',
    templateUrl: './with-datasource.component.html'
} )
export class TitleFormComponent extends WithDatasourceComponent<GenericValue>   {

    constructor() {
        super(
            {
                datasourceName: 'api/v1/rm/erp/person/value/salutationtitle',
                fieldDisplayName: 'text',
                i18nIdentifier: 'rm.erp.jobapplication.JobApplication.title',
            } );
    }

    set value( t: GenericValue | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.title = t;
        }
    }

    get value(): GenericValue | undefined {
        return this.jobapplication?.title;
    }

    getFieldValue( t?: GenericValue ): string | undefined {
        return t?.text;
    }
}
